import { ArrowLeftRight } from "lucide-react";
import React, { useState } from "react";

const WithdrawModal = ({
  isOpen,
  onClose,
  walletData,
  onWithdraw,
}) => {
  const [amount, setAmount] = useState("");

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/30 backdrop-blur-md">
      
      {/* Bottom Sheet */}
      <div className="w-full max-w-md bg-purple-100 rounded-t-3xl p-5 animate-slideUp">

        {/* Drag Handle */}
        <div className="w-10 h-1 bg-gray-300 rounded-full mx-auto mb-4"></div>

        {/* Header */}
        <div className="flex items-center justify-between gap-2 mb-4">
          
          <h2 className="font-semibold text-[#34163F] text-lg">
           ✔ Request Withdrawal
          </h2>
          <button onClick={onClose} className="text-black">✕</button>
        </div>

        {/* Available Box */}
        <div className="bg-white rounded-2xl p-4 mb-4">
          <div className="flex justify-between items-center mb-3">
            <p className="text-sm font-bold text-gray-700 text-left">
              Available To<br></br> Withdraw
            </p>
            <span className="text-xs bg-purple-100 text-[#34163F] px-2 py-1 rounded-full">
              Contest → Referral → Quiz
            </span>
          </div>

          <div className="grid grid-cols-3 gap-2 h-15 w-15 text-center">
            <div className="bg-purple-100 rounded-xl p-2">
              <p className="text-xs text-gray-400">Contest</p>
              <p className="font-bold text-gray-600">{walletData.contestBalance}</p>
            </div>

            <div className="bg-purple-100 rounded-xl p-2">
              <p className="text-xs text-gray-400">Referral</p>
              <p className="font-bold text-gray-600">{walletData.referralBalance}</p>
            </div>

            <div className="bg-purple-100 rounded-xl p-2">
              <p className="text-xs text-gray-400">Quiz</p>
              <p className="font-bold text-gray-600">{walletData.lockedBalance}</p>
            </div>
          </div>

          <p className="text-xs text-gray-400 mt-3 text-left">
            Purchased credits are non-withdrawable and can only be used within the platform.
          </p>
        </div>

        {/* Conversion Box */}
        <div className="bg-white rounded-2xl p-4 mb-4 flex items-center justify-between">
          
          <div>
            <p className="text-xl font-bold text-gray-900">{amount || 0}</p>
            <p className="text-xs text-gray-800">Credits</p>
          </div>

          <div className="w-10 h-10 flex items-center justify-center bg-[#34163F] text-white rounded-full text-lg">
            <ArrowLeftRight></ArrowLeftRight>
          </div>

          <div className="text-right">
            <p className="text-xl font-bold text-gray-900">
              ₹{amount ? (amount * 0.01).toFixed(2) : "0.00"}
            </p>
            <p className="text-xs text-gray-800">(Estimated)</p>
          </div>
        </div>

        {/* Label */}
        <p className="text-sm text-black mb-2 text-left font-medium">
          Enter Credits To Withdraw
        </p>

        {/* Input */}
        <input
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder={`${walletData.totalBalance}`}
          className="w-full p-3 rounded-xl bg-[#34163F] text-white placeholder-white/70 outline-none mb-3 text-center text-lg font-semibold"
        />

        {/* Info */}
        <p className="text-xs text-orange-500 mb-4">
          Minimum withdrawal threshold applies (5 Credits)
        </p>

        {/* Button */}
        <button
          onClick={() => {
             onWithdraw(Number(amount))
            onClose();
          }}
          className="w-full bg-[#34163F] text-white py-3 rounded-full font-semibold text-lg"
        >
          Proceed
        </button>
      </div>
    </div>
  );
};

export default WithdrawModal;